import { RESCHEDULE_EXCEPTION_REASON } from "./unsuccessful-reasons";

// The exact reason that counts as a RocketHealth-initiated reschedule within
// 24 hours of the session (surfaced in the user summary's "Rescheduled by RH
// <24hrs" tile).
export const RH_RESCHEDULE_LT24_REASON =
  "Reschedule by professional <24 hours";

export const CANCELLATION_REASONS = [
  "Reschedule by professional >24 hours",
  RH_RESCHEDULE_LT24_REASON,
  RESCHEDULE_EXCEPTION_REASON,
  "Dummy booking",
  "Refund request",
  "Change of professionals",
  "Language discrepancy",
  "Age discrepancy",
  "Consent form pending",
  "Internal: Tech team testing",
  "Reschedule/cancellation requested by user",
  "Close-by booking",
  "Incorrect credentials",
  "Others (type reason manually if not listed)",
] as const;

export type CancellationReason = typeof CANCELLATION_REASONS[number];

